module.exports = __webpack_public_path__ + "img/BreakfastAtWohnwagen.f864c889.svg";